module.exports = __webpack_public_path__ + "static/media/savest.3fadb816.svg";